export default __webpack_public_path__ + "static/media/logo4.2511884e.png";